var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A4A4A",
    d: "M27.071 18.558a.796.796 0 00-.637-.318H5.013V4.293a2.704 2.704 0 012.7-2.7h1.46a2.704 2.704 0 012.61 2.073 4.182 4.182 0 00-3.292 4.083v.589c0 .44.356.796.796.796h6.761c.44 0 .797-.356.797-.796v-.59a4.179 4.179 0 00-3.437-4.108A4.296 4.296 0 009.172 0H7.714A4.296 4.296 0 003.42 4.293v13.94H.955a.796.796 0 00-.758 1.039l2.23 6.962c.29.907.833 1.712 1.567 2.318l-.956 1.42a.796.796 0 001.322.89l1.016-1.507a4.981 4.981 0 001.79.318h13.07c.618 0 1.23-.116 1.806-.34l.994 1.506a.796.796 0 101.328-.876l-.955-1.436a4.965 4.965 0 001.554-2.31l2.23-6.961a.796.796 0 00-.122-.698zM12.67 5.166a2.586 2.586 0 012.574 2.376h-5.15a2.586 2.586 0 012.576-2.376zm10.787 20.58a3.37 3.37 0 01-3.22 2.35H7.154a3.37 3.37 0 01-3.22-2.35l-1.91-5.924H25.35l-1.895 5.924z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.259,
    cy: 13.682,
    r: 1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.077,
    cy: 13.682,
    r: 1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.851,
    cy: 16.09,
    r: 1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.669,
    cy: 16.09,
    r: 1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.484,
    cy: 16.09,
    r: 1,
    fill: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.666,
    cy: 11.268,
    r: 1,
    fill: "#000"
  }))));
}
export default SvgBathroom;